export function convertToUTC(localDate, localTime) {
  const localDateTime = new Date(`${localDate}T${localTime}`);

  const utcHours = String(localDateTime.getUTCHours()).padStart(2, "0");
  const utcMinutes = String(localDateTime.getUTCMinutes()).padStart(2, "0");

  console.log("time", `${localTime}:${localDateTime}:00`);
  return `${utcHours}:${utcMinutes}:00`;
}